import type { DiscountDataKeys } from '@app/pages/ProcessingResultsPageInner/ui/PricesBlock/types'
import type { PricesBlock } from '@app/pages/ProcessingResultsPageInner/types'

export const titlesMap: Partial<Record<keyof PricesBlock, string>> = {
  discount: 'Скидка',
  discountMechanics: 'Механика скидки'
}

export const targetKeys: DiscountDataKeys[] = ['discount', 'discountMechanics']
